"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redditSearch = exports.redditSearchResultSchema = exports.redditSearchArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.redditSearchArgsSchema = zod_1.z.object({
    query: zod_1.z.string().describe('The search query for Reddit search'),
    subreddit: zod_1.z.string().describe('Optional subreddit to search within').nullish(),
    maxResults: zod_1.z.number().describe('required: Maximum number of results to return: default to 10'),
    options: zod_1.z
        .object({
        time: zod_1.z
            .enum(['all', 'hour', 'day', 'week', 'month', 'year'])
            .describe('Time filter for search results')
            .nullish(),
        sort: zod_1.z
            .enum(['relevance', 'hot', 'top', 'new', 'comments'])
            .describe('Sort order for search results')
            .nullish(),
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Default to true.'),
    })
        .describe('Search options'),
    emitMode: common_1.emitModeSchema.default('multi').describe('Emit mode for the tool. Default to "multi".'),
});
// Result schema
exports.redditSearchResultSchema = zod_1.z.array(zod_1.z.object({
    title: zod_1.z.string(),
    id: zod_1.z.string(),
    url: zod_1.z.string(),
    content: zod_1.z.string(),
    imageUrl: zod_1.z.string(),
    subreddit: zod_1.z.string(),
    author: zod_1.z.string(),
    created_utc: zod_1.z.number(),
    num_comments: zod_1.z.number(),
    score: zod_1.z.number(),
    thumbnails: zod_1.z.array(zod_1.z.string()),
}));
// Tool definition
exports.redditSearch = (0, common_1.createEmitModeToolMetadata)({
    id: 'redditSearch',
    displayName: 'Reddit Search',
    displayDescription: 'Search Reddit for posts and content',
    category: 'social',
    color: common_1.BRAND_COLORS.REDDIT,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.REDDIT),
    icon: 'reddit',
    argsSchema: exports.redditSearchArgsSchema,
}, exports.redditSearchResultSchema);
